
import styled, { css } from "styled-components";
import { transparentize, lighten } from "polished";
import { Bar as NonBar } from "../shared-style";

import { IMarkedStyleProps } from "./interfaces";

export const Bar = styled(NonBar)`
    background-color: ${p => transparentize(1 - 0.4, p.theme.c.active)};

    &:hover {
        background-color: ${p => transparentize(1 - 0.8, p.theme.c.active)};
    }
`;

export const Mark = styled.div`
    position: absolute;
    bottom: 14px;
`;

export const Marked = styled.div<IMarkedStyleProps>`
    position: absolute;
    left: 50%;
    top: 50%;
    width: 40px;
    height: 40px;
    margin-top: -20px;
    margin-left: -20px;
    text-align: center;
    background-color: ${p => p.theme.c.pale};
    color: white;
    font-weight: 500;
    font-size: 26px;
    line-height: 40px;
    border-radius: 20px;
    border: solid 2px white;
    box-sizing: border-box;

    ${p =>
        p.active
            ? css`
                  color: white;
                  background-color: ${p.theme.c.active};

                  .Counter {
                      background-color: ${p.theme.c.active};
                  }
              `
            : undefined}
    ${p =>
        p.add
            ? css`
                  display: inline-block;
                  margin: 0 12px;
                  position: static;
                  box-shadow: 0 0 3px 0 ${lighten(0.1, p.theme.c.active)};
                  position: relative;
                  top: auto;
                  line-height: 36px;
                  left: auto;
                  cursor: pointer;
                  text-shadow: 0 0 1px white;
              `
            : undefined}
`;

export const Counter = styled.div`
    position: absolute;
    bottom: -11px;
    right: -11px;
    background-color: ${p => p.theme.c.pale};
    box-shadow: 0 0 3px 0 ${p => lighten(0.1, p.theme.c.active)};
    border: white solid 2px;
    box-sizing: border-box;
    font-size: 18px;
    width: 24px;
    height: 24px;
    border-radius: 12px;
    line-height: 20px;
`;
